import { YES } from '../constants';
import urls from './urls';
import { axiosPost, axiosPut, getSourceId } from './common';
import { addAnalyticEvent } from '../analytics/common';
import { confirmPostalUnsub } from '../analytics/address';

function buildAddressRequest(address) {
  return {
    ...address,
    sourceId: getSourceId(),
  };
}

export function unsubscribeDirectMail(address, callback, err) {
  const request = {
    ...buildAddressRequest(address),
    globalOptOut: YES,
  };

  const successCallback = (res) => {
    try {
      callback(res);
    } finally {
      addAnalyticEvent(confirmPostalUnsub);
    }
  };

  axiosPut({
    url: urls.UPDATE_DIRECT_MAIL,
    data: request,
    callback: successCallback,
    err
  });
}

export function standardizeAddress(address, callback, err) {
  const request = buildAddressRequest(address);

  axiosPost({
    url: urls.STANDARDIZE_ADDRESS,
    data: request,
    callback,
    err
  });
}
